<template>
  <div>
    <exo-table :root="_self">
      <exo-form :root="_self">
        <exo-input-name :root="_self" />
        <exo-input-double :root="_self" name="nominalCapacity" />
        <exo-input-double :root="_self" name="depthOfDischarge">
          <exo-help-dialog title="Battery depth of discharge">
            This is the maximum allowed value for the battery discharge. It is
            expressed as a percentage of the battery capacity.
            <br />
            <br />
            <v-img
              contain
              :src="require('../../assets/images/tooltip-battery.png')"
              aspect-ratio="2.5"
            />
            <br />
            <br />
            <strong>Example</strong>: for a battery with a depth of discharge of
            30%, the battery charge will not be allowed to drop below 70%.
          </exo-help-dialog>
        </exo-input-double>
        <exo-input-double :root="_self" name="minimumChargeForFiring">
          <exo-help-dialog title="Minimum charge for firing">
            This is the minimum allowed value for the battery before firing. It
            is expressed as a percentage of the battery capacity.
            <br />
            In general, this is a difficult parameter to evaluate since it
            depends on the manoeuvring strategy. It can be estimated thanks to
            the <i>Maneuvering Strategy Design</i> mission.
            <br />
          </exo-help-dialog>
        </exo-input-double>
      </exo-form>
    </exo-table>
    <exo-modal-references :root="_self" :modalContent="this.modalRef" />
  </div>
</template>

<script>
import formMixin from '../../mixins/forms.js'
import numericalMixin from '../../mixins/numericalForms.js'

export default {
  name: 'batteryDefinition',

  mixins: [formMixin, numericalMixin],

  computed: {},

  data() {
    return {
      tableFields: [
        { value: 'displayedName', text: 'Name', sortable: true },
        {
          value: 'nominalCapacity',
          text:
            'Nominal capacity' + this.getDefaultUnitLabel('nominalCapacity'),
          sortable: true
        },
        {
          value: 'depthOfDischarge',
          text:
            'Depth of discharge' + this.getDefaultUnitLabel('depthOfDischarge'),
          sortable: true
        },
        {
          value: 'minimumChargeForFiring',
          text:
            'Minimum charge for firing' +
            this.getDefaultUnitLabel('minimumChargeForFiring'),
          sortable: true
        },
        { value: 'actions', text: 'Actions', sortable: false }
      ],

      modalRef: { content: [] },
      showModal: false,

      inputs: {
        nominalCapacity: this.getDefaultValue('nominalCapacity'),
        depthOfDischarge: this.getDefaultValue('depthOfDischarge'),
        minimumChargeForFiring: this.getDefaultValue('minimumChargeForFiring')
      }
    }
  },

  methods: {
    getCurrentFormType() {
      return 'BatteryDefinition'
    },

    getRefList(param) {
      return []
    }
  }
}
</script>
